import { SimulationReportPAGE } from './simulation-report-page.component';

export default SimulationReportPAGE;
